import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { baseUrl } from '../Data/service/global.service';

@Injectable({ providedIn: 'root' })
export class AuthorityConnectionService {
  private _showBanner$ = new BehaviorSubject<boolean>(false);
  private _companyId: number | null = null;
  private _message: string = '';
  private _status: number = 0;

  get showBanner$() {
    return this._showBanner$.asObservable();
  }

  get companyId() {
    return this._companyId;
  }

  get message() {
    return this._message;
  }

  /** 404 = لم تربط بعد، 406 = انتهت الصلاحية */
  get status() {
    return this._status;
  }

  constructor(private http: HttpClient) {}

  showBanner(companyId: number, message: string, status?: number) {
    if (status === 404 || status === 406) {
      this._companyId = companyId;
      this._message = message;
      this._status = status;
      this._showBanner$.next(true);
    }
  }

  hideBanner() {
    this._showBanner$.next(false);
    this._companyId = null;
    this._message = '';
    this._status = 0;
  }

  /** يطلب رابط الربط من الـ Backend ويُعيد الـ URL */
  connectToTaxAuthority(): Observable<{ url: string }> {
    if (!this._companyId) {
      return throwError(() => new Error('No company ID'));
    }
    const params = new HttpParams().set('companyId', String(this._companyId));
    return this.http.get<{ url: string }>(`${baseUrl}ita-oauth/authorization-url`, { params });
  }
}
